// API Paths that are exempt from CSRF token check
export const EXEMPT_PATHS = [
  "/csurf/token",
  "/log/event",
];

// Helper function to check if a URL is exempt from CSRF token check
export const isExemptPath = (url) => {
  return EXEMPT_PATHS.includes(url);
};
